<template>
  <section id="introduce" class="introduce">
    <a-typography>
      <a-typography-title :level="2">
        星汉未来(Galaxy-Future)
      </a-typography-title>
    </a-typography>
    <a-typography-paragraph>
      <p v-for="(item, index) in expand.textList" :key="index"> >{{ item }}</p>
    </a-typography-paragraph>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'sso_introduce',
  data():DataInterface {
    return {
      expand:{
        textList: [
              "星汉未来（Galaxy-Future）是一家拥有先进云原生和Serverless能力的基础软件服务商，并为用户提供实时互动数字人、云应用市场、应用托管平台等多个产品服务。",
              "星汉未来实时互动数字人业务，满足用户的多样化需求。个人用户可以打造个性化虚拟形象，企业也能够借此提升品牌形象、拓展营销渠道，开启虚实融合的全新体验。",
              "星汉未来云应用市场汇集大量热门易用的 AI聊天、AI学术助手、AI绘画等AIGC工具及企业应用，一键启用无需繁琐部署操作。",
              "星汉未来应用托管平台帮助用户实现分钟级应用部署、无人化运维保障和自动化成本治理，大幅提升部署运维效率。"
          ]
      }
    } 
  }
 
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}sso/';

.introduce {
  overflow: hidden;
  float: right;
  position: relative;
  width: 98%;
  max-width: 550px;
  padding: 50px;
  margin: 0;
  background-color: fade(@color_white, 95);
  
  article.ant-typography {
    float: left;
    padding: 0 0 20px;
    border-bottom: 1px solid @color_black;
  }
  
  h1.ant-typography {
    margin: 0;
    .font(left, 60px, @color_black, 58px, true);
  }
  
  h2.ant-typography {
    margin: 10px 0 0;
    .font(left, 34px, @color_black, 32px, true);
  }
  
  div.ant-typography {
    float: left;
    width: 100%;
    margin: 20px 0 0;
    .font(justify, @font_6+@line, @color_black, @font_6);
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .introduce {
    float: none;
    padding: 40px;
    margin: 10px auto 0;
    
    h1.ant-typography {
      margin: 0;
      .font(left, 50px, @color_black, 48px, true);
    }
    
    h2.ant-typography {
      margin: 10px 0 0;
      .font(left, 30px, @color_black, 28px, true);
    }
  }
}
</style>